/* eslint-disable no-unused-vars */
import { create } from 'zustand'

type IActionsProps = {
  toggleLoading: (value: boolean) => void
  toggleLockLoading: (value: boolean) => void
  toggleInitialLoading: (value: boolean) => void
}

type IStoreProps = {
  loading: boolean
  lockLoading: boolean
  initialLoading: boolean
  actions: IActionsProps
}

export const ZuLoadingStore = create<IStoreProps>((set) => ({
  loading: false,
  lockLoading: false,
  initialLoading: true,
  actions: {
    toggleLoading: (value) => set(() => ({ loading: value })),
    toggleLockLoading: (value) => set(() => ({ lockLoading: value })),
    toggleInitialLoading: (value) => set(() => ({ initialLoading: value })),
  },
}))
